import * as React from 'react'

function SvgNotiBell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm1.583 16.43h-3a1.5 1.5 0 103 0zM12 5.326a.758.758 0 00-.753.831 3.773 3.773 0 00-1.923 1.034 3.776 3.776 0 00-1.11 2.677v.769l-.007.293c-.04.82-.232 1.929-.467 2.633l-.8 2.4-.024.09c-.07.352.158.63.546.63h9.075l.093-.006c.362-.045.551-.348.428-.714l-.799-2.4-.085-.28c-.221-.791-.389-1.906-.39-2.647v-.769l-.004-.195a3.788 3.788 0 00-3.027-3.515.756.756 0 00-.753-.831z"
      />
    </svg>
  )
}

export default SvgNotiBell
